export const PortfolioAnalysisIcon = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 15.1665H14"
        stroke="#010D1D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.73332 6.08691H2.66667C2.3 6.08691 2 6.38691 2 6.75358V12.5002C2 12.8669 2.3 13.1669 2.66667 13.1669H3.73332C4.09998 13.1669 4.39998 12.8669 4.39998 12.5002V6.75358C4.39998 6.38691 4.09998 6.08691 3.73332 6.08691Z"
        stroke="#010D1D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.53312 3.96045H7.46647C7.0998 3.96045 6.7998 4.26045 6.7998 4.62712V12.5004C6.7998 12.8671 7.0998 13.1671 7.46647 13.1671H8.53312C8.89979 13.1671 9.19979 12.8671 9.19979 12.5004V4.62712C9.19979 4.26045 8.89979 3.96045 8.53312 3.96045Z"
        stroke="#010D1D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3339 1.8335H12.2673C11.9006 1.8335 11.6006 2.1335 11.6006 2.50016V12.5002C11.6006 12.8668 11.9006 13.1668 12.2673 13.1668H13.3339C13.7006 13.1668 14.0006 12.8668 14.0006 12.5002V2.50016C14.0006 2.1335 13.7006 1.8335 13.3339 1.8335Z"
        stroke="#292D32"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
